module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_arrow_right04-1085a08dbe760afa0d802f17c110f50a.svg";